import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

function dm_c_07_related_insights_cards() {
  const sections = document.querySelectorAll('.c-07-related-insights-cards');

  sections.forEach((section) => {
    const viewport = section.querySelector('.cards-swiper');
    if (!viewport) return;

    const wrapper = viewport.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const slides = wrapper.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    // mobile under md (< 991px)
    const mq = '(max-width: 991.98px)';
    let swiperInstance = null;
    let resizeTimer = null;

    function initSwiper() {
      if (swiperInstance) return;
      if (!window.matchMedia(mq).matches) return;

      try {
        swiperInstance = new Swiper(viewport, {
          modules: [Pagination],
          slidesPerView: 1,
          spaceBetween: 12,
          speed: 400,
          pagination: {
            el: viewport.querySelector('.swiper-pagination') || null,
            clickable: true,
          },
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Swiper init failed:', err);
      }
    }

    function destroySwiper() {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.matchMedia(mq).matches) {
          initSwiper();
        } else {
          destroySwiper();
        }
      }, 120);
    }

    // initial
    if (window.matchMedia(mq).matches) initSwiper();
    window.addEventListener('resize', onResize);

    const mo = new MutationObserver(() => {
      if (!document.body.contains(section)) {
        destroySwiper();
        window.removeEventListener('resize', onResize);
        mo.disconnect();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
}

export { dm_c_07_related_insights_cards };